/* Leverson — behaviours ported 1:1 from the Figma site (leverson.figma.site) */
(function () {
  'use strict';
  var d = document, w = window;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var lang = (d.documentElement.lang || 'it').slice(0, 2);
  var isIt = lang === 'it', isHi = lang === 'hi';
  var ROOT = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';

  /* ---------- page overlay (fade from ink on every page load) ---------- */
  var overlay = $('#page-overlay');
  function overlayIn() {
    if (!overlay) return;
    overlay.style.transition = 'none';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'all';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.style.transition = 'opacity 0.45s ease';
        overlay.style.opacity = '0';
        setTimeout(function () { overlay.style.pointerEvents = 'none'; }, 450);
      });
    });
  }
  overlayIn();
  w.addEventListener('pageshow', function (e) { if (e.persisted) overlayIn(); });
  d.addEventListener('click', function (e) {
    if (!overlay || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    if (/^\/(checkout|cart\/c\/)/.test(u.pathname)) return;
    e.preventDefault();
    overlay.style.transition = 'opacity 0.25s ease';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'all';
    setTimeout(function () { location.href = a.href; }, 240);
  });

  /* ---------- custom cursor (dot + lerped ring) ---------- */
  (function () {
    var dot = $('.custom-cursor'), ring = $('.custom-cursor-ring');
    if (!dot || !ring) return;
    var x = 0, y = 0, t = { x: -100, y: -100 };
    d.addEventListener('mousemove', function (e) {
      t.x = e.clientX; t.y = e.clientY;
      dot.style.left = (t.x - 5) + 'px'; dot.style.top = (t.y - 5) + 'px';
    });
    (function loop() {
      x += (t.x - x) * 0.1; y += (t.y - y) * 0.1;
      ring.style.left = (x - 18) + 'px'; ring.style.top = (y - 18) + 'px';
      requestAnimationFrame(loop);
    })();
    function on() { dot.classList.add('hovering'); ring.classList.add('hovering'); }
    function off() { dot.classList.remove('hovering'); ring.classList.remove('hovering'); }
    d.addEventListener('mouseover', function (e) { if (e.target.closest && e.target.closest('a, button')) on(); });
    d.addEventListener('mouseout', function (e) { if (e.target.closest && e.target.closest('a, button')) off(); });
  })();

  /* ---------- navigation ---------- */
  var nav = $('[data-lv-nav]');
  var menuOpen = false;
  if (nav) {
    var blur = $('[data-lv-blur]', nav);
    var kind = nav.getAttribute('data-nav-kind');
    var menu = $('[data-lv-mobile-menu]');
    var burger = $('[data-lv-burger]', nav);
    var isHome = kind === 'home';

    var applyBlur = function () {
      var y = w.scrollY, s = Math.min(y / 180, 1);
      blur.classList.toggle('navigation-blur--hero', isHome && !menuOpen);
      blur.classList.toggle('navigation-blur--scrolled', y > 60 && !isHome);
      blur.style.setProperty('--home-header-alpha', isHome ? String(menuOpen ? 0.78 : s * 0.6) : '1');
      if (isHome) {
        var bf = (menuOpen || s > 0.02) ? 'blur(' + (menuOpen ? 18 : (s * 18).toFixed(1)) + 'px) saturate(.65)' : 'none';
        blur.style.backdropFilter = bf; blur.style.webkitBackdropFilter = bf;
      } else { blur.style.backdropFilter = ''; blur.style.webkitBackdropFilter = ''; }
    };
    applyBlur();
    w.addEventListener('scroll', applyBlur, { passive: true });

    /* active link + hover colour */
    var path = location.pathname.replace(/\/$/, '');
    var activeMap = {
      shop: path.indexOf('/collections') === 0 || path.indexOf('/products') === 0 || path === '/search',
      materials: path === '/pages/materiali',
      about: path === '/pages/about'
    };
    var COPPER = 'var(--color-copper)', DIM = 'rgba(245,240,232,0.8)';
    $$('[data-nav-link]', nav).forEach(function (a) {
      var act = !!activeMap[a.getAttribute('data-nav-link')];
      if (a.getAttribute('data-nav-link') === 'shop') act = path.indexOf('/collections') === 0;
      if (act) { a.classList.add('is-active'); a.style.color = COPPER; }
      a.addEventListener('mouseenter', function () { a.style.color = COPPER; });
      a.addEventListener('mouseleave', function () { a.style.color = act ? COPPER : DIM; });
    });

    /* COLLEZIONI dropdown */
    var box = $('[data-lv-collections]', nav);
    if (box) {
      var btn = $('[data-lv-collections-btn]', box), mnu = $('[data-lv-collections-menu]', box), chev = $('[data-lv-chev]', box);
      var inArchive = path === '/pages/archive';
      if (inArchive) { btn.classList.add('is-active'); btn.style.color = COPPER; }
      var timer = null, hovered = null;
      var years = $$('[data-lv-year]', box);
      var render = function (open) {
        mnu.classList.toggle('is-open', open);
        mnu.style.pointerEvents = open ? 'all' : 'none';
        chev.style.transform = open ? 'rotate(180deg)' : 'rotate(0deg)';
        years.forEach(function (y) {
          var yr = y.getAttribute('data-lv-year'), row = $('[data-lv-year-row]', y), sub = $('[data-lv-year-sub]', y);
          var isH = hovered === yr;
          row.style.opacity = open ? 1 : 0;
          row.style.transform = open ? 'translateY(0)' : 'translateY(-6px)';
          row.style.transitionDelay = open ? (parseFloat(row.getAttribute('data-delay')) || 0) + 's' : '0s';
          row.style.background = isH ? 'rgba(202, 114, 50, 0.1)' : 'transparent';
          var spans = row.children;
          spans[0].style.color = isH ? COPPER : 'rgba(245,240,232,0.85)';
          spans[1].style.color = isH ? COPPER : 'rgba(245,240,232,0.3)';
          spans[1].style.transform = isH ? 'translateX(2px)' : 'none';
          sub.style.clipPath = isH ? 'inset(0 0% 0 0)' : 'inset(0 100% 0 0)';
          sub.style.pointerEvents = isH ? 'all' : 'none';
          $$('[data-lv-sub-item]', sub).forEach(function (it, n) {
            it.style.opacity = isH ? 1 : 0;
            it.style.transform = isH ? 'translateX(0)' : 'translateX(-4px)';
            it.style.transitionDelay = isH ? (n * 0.06) + 's' : '0s';
          });
        });
      };
      render(false);
      var openMenu = function () { if (timer) clearTimeout(timer); render(true); };
      var closeSoon = function () { timer = setTimeout(function () { hovered = null; render(false); }, 120); };
      box.addEventListener('mouseenter', openMenu);
      box.addEventListener('mouseleave', closeSoon);
      mnu.addEventListener('mouseenter', function () { if (timer) clearTimeout(timer); });
      mnu.addEventListener('mouseleave', closeSoon);
      years.forEach(function (y) {
        var yr = y.getAttribute('data-lv-year');
        y.addEventListener('mouseenter', function () { hovered = yr; render(true); });
        y.addEventListener('mouseleave', function () { hovered = null; render(true); });
        $$('[data-lv-sub-item]', y).forEach(function (it) {
          it.addEventListener('mouseenter', function () { it.style.background = 'rgba(202, 114, 50, 0.1)'; });
          it.addEventListener('mouseleave', function () { it.style.background = 'transparent'; });
        });
      });
      btn.addEventListener('mouseenter', function () { btn.style.color = COPPER; });
      btn.addEventListener('mouseleave', function () { btn.style.color = inArchive ? COPPER : DIM; });
      btn.addEventListener('click', function () { location.href = btn.getAttribute('data-href'); });
    }

    /* language select */
    var lang$ = $('[data-lv-lang]', nav);
    if (lang$) {
      var lbtn = $('[data-lv-lang-btn]', lang$), lmenu = $('.language-select__menu', lang$), lchev = $('.language-select__chevron', lang$);
      var lopts = $$('.language-select__option', lang$);
      var setLang = function (open) {
        lmenu.classList.toggle('is-open', open);
        lchev.classList.toggle('is-open', open);
        lbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        lopts.forEach(function (o) { o.style.transitionDelay = open ? (parseInt(o.getAttribute('data-delay'), 10) || 0) + 'ms' : '0ms'; });
      };
      lbtn.addEventListener('click', function () { setLang(!lmenu.classList.contains('is-open')); });
      d.addEventListener('mousedown', function (e) { if (!lang$.contains(e.target)) setLang(false); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setLang(false); });
    }

    /* mobile menu */
    var setMenu = function (open) {
      menuOpen = open;
      menu.classList.toggle('open', open);
      d.body.style.overflow = open ? 'hidden' : '';
      var sp = burger.children;
      sp[0].style.transform = open ? 'translateY(6px) rotate(45deg)' : 'none';
      sp[1].style.opacity = open ? 0 : 1;
      sp[2].style.transform = open ? 'translateY(-6px) rotate(-45deg)' : 'none';
      $$('.lv-mm-lang', menu).forEach(function (b) { b.style.opacity = open ? 1 : 0; });
      applyBlur();
    };
    burger.addEventListener('click', function () { setMenu(!menuOpen); });
    $('[data-lv-menu-close]', menu).addEventListener('click', function () { setMenu(false); });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-lv-cart-drawer]'), cOverlay = $('[data-lv-cart-overlay]');
  var cartState = null;
  function money(c, cur) {
    var v = (c / 100).toLocaleString(isIt ? 'it-IT' : 'en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return (cur === 'EUR' || !cur ? '€' : cur + ' ') + v;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function setCount(n) {
    $$('[data-lv-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; b.style.display = n < 1 ? 'none' : 'flex'; });
    $$('[data-lv-cart-open]').forEach(function (b) {
      var base = (b.getAttribute('aria-label') || '').replace(/\d+/, n);
      b.setAttribute('aria-label', base);
    });
  }
  function renderCart(cart) {
    cartState = cart;
    setCount(cart.item_count);
    if (!drawer) return;
    var body = $('[data-lv-cart-body]', drawer), foot = $('[data-lv-cart-foot]', drawer);
    var T = function (k) { return drawer.getAttribute('data-' + k); };
    if (!cart.items.length) {
      body.style.padding = '3rem 2rem';
      body.innerHTML = '<div style="text-align:center"><p style="font-family:var(--font-sans);font-size:0.86rem;color:var(--color-warm-gray);letter-spacing:0.05em">' + esc(T('empty')) + '</p><button type="button" data-lv-cart-close style="margin-top:1.5rem;font-family:var(--font-sans);font-size:0.76rem;letter-spacing:0.2em;color:var(--color-ink);background:none;border:1px solid var(--color-ink);padding:0.75rem 2rem;cursor:pointer;transition:background 0.2s ease,color 0.2s ease">' + esc(T('continue')) + '</button></div>';
      foot.hidden = true; foot.innerHTML = '';
      return;
    }
    body.style.padding = '0';
    body.innerHTML = cart.items.map(function (it) {
      var opts = (it.options_with_values || []).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      var sz = '', col = '';
      (it.options_with_values || []).forEach(function (o) {
        if (/tagli|size/i.test(o.name)) sz = o.value;
        else if (/color|colou/i.test(o.name)) col = o.value;
      });
      var meta = (sz || col) ? (T('size') + ': ' + esc(sz || '—') + ' · ' + T('color') + ': ' + esc(col || '—')) : opts;
      return '<div style="display:grid;grid-template-columns:90px 1fr;gap:1.2rem;padding:1.5rem 2rem;border-bottom:1px solid var(--color-warm-beige)">' +
        '<img src="' + esc((it.image || '').replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2')) + '" alt="' + esc(it.product_title) + '" style="width:90px;height:120px;object-fit:cover;display:block">' +
        '<div><p style="font-family:var(--font-serif);font-size:0.93rem;margin:0 0 0.25rem;color:var(--color-ink)">' + esc(it.product_title) + '</p>' +
        '<p style="font-family:var(--font-sans);font-size:0.80rem;color:var(--color-warm-gray);margin:0 0 0.5rem;letter-spacing:0.05em">' + meta + '</p>' +
        '<p style="font-family:var(--font-sans);font-size:0.90rem;color:var(--color-ink);margin:0 0 1rem;font-weight:500">' + money(it.final_line_price / it.quantity, cart.currency) + '</p>' +
        '<div style="display:flex;align-items:center;justify-content:space-between"><div style="display:flex;align-items:center;border:1px solid var(--color-warm-beige)">' +
        '<button type="button" data-lv-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" style="width:28px;height:28px;background:none;border:none;cursor:pointer;font-family:var(--font-sans);font-size:1rem;color:var(--color-ink)">−</button>' +
        '<span style="font-family:var(--font-sans);font-size:0.83rem;width:24px;text-align:center;color:var(--color-ink)">' + it.quantity + '</span>' +
        '<button type="button" data-lv-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" style="width:28px;height:28px;background:none;border:none;cursor:pointer;font-family:var(--font-sans);font-size:1rem;color:var(--color-ink)">+</button></div>' +
        '<button type="button" data-lv-qty="' + esc(it.key) + '" data-q="0" style="font-family:var(--font-sans);font-size:0.73rem;letter-spacing:0.1em;color:var(--color-warm-gray);background:none;border:none;cursor:pointer;text-decoration:underline;text-underline-offset:3px">' + esc(T('remove')) + '</button></div></div></div>';
    }).join('');
    foot.hidden = false;
    foot.innerHTML = '<div style="display:flex;justify-content:space-between;margin-bottom:1.25rem"><span style="font-family:var(--font-sans);font-size:0.80rem;letter-spacing:0.15em;color:var(--color-warm-gray)">' + esc(T('subtotal')) + '</span><span style="font-family:var(--font-serif);font-size:1.1rem;color:var(--color-ink)">' + money(cart.items_subtotal_price, cart.currency) + '</span></div>' +
      '<a href="/checkout" data-lv-checkout style="display:block;text-align:center;text-decoration:none;width:100%;padding:1rem;background:var(--color-ink);color:var(--color-ivory);font-family:var(--font-sans);font-size:0.80rem;letter-spacing:0.2em;border:none;cursor:pointer;transition:background 0.2s ease">' + esc(T('checkout')) + '</a>';
  }
  function refresh() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }).catch(function () {});
  }
  var Cart = {
    open: function () { refresh(); if (drawer) { drawer.classList.add('open'); cOverlay.classList.add('open'); } },
    close: function () { if (drawer) { drawer.classList.remove('open'); cOverlay.classList.remove('open'); } },
    add: function (id, qty) {
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok) { var e = new Error((b && (b.description || b.message)) || 'add'); e.shopify = true; throw e; } return b; }); })
        .then(function () { return refresh(); });
    },
    change: function (key, q) {
      return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    },
    refresh: refresh
  };
  w.LvCart = Cart;
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-lv-cart-open]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-lv-cart-close]') || t === cOverlay) { Cart.close(); return; }
    var q = t.closest('[data-lv-qty]');
    if (q) Cart.change(q.getAttribute('data-lv-qty'), parseInt(q.getAttribute('data-q'), 10));
  });
  d.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('[data-lv-cart-close]');
    if (b && b.tagName === 'BUTTON' && b.textContent.trim() !== '✕') { b.style.background = 'var(--color-ink)'; b.style.color = 'var(--color-ivory)'; }
  });
  d.addEventListener('mouseout', function (e) {
    var b = e.target.closest && e.target.closest('[data-lv-cart-close]');
    if (b && b.tagName === 'BUTTON' && b.textContent.trim() !== '✕') { b.style.background = 'none'; b.style.color = 'var(--color-ink)'; }
  });
  if (drawer) refresh();

  /* ---------- scroll reveal (same trigger as the Figma useReveal hook) ---------- */
  (function () {
    var SEL = '.reveal, .reveal-clip, .reveal-left, .text-line-inner';
    var items = $$(SEL).filter(function (el) { return !el.closest('[data-lv-hero]'); });
    var roots = [];
    items.forEach(function (el) {
      var r = el.closest('[data-reveal-root]') || el.closest('section') || el;
      if (roots.indexOf(r) < 0) roots.push(r);
    });
    var done = function (r) {
      $$(SEL, r).forEach(function (e) { e.classList.add('visible'); });
      r.classList.add('visible');
    };
    if (!('IntersectionObserver' in w)) { roots.forEach(done); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { done(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    roots.forEach(function (r) { io.observe(r); });
  })();

  /* ---------- home hero entrance ---------- */
  (function () {
    var hero = $('[data-lv-hero]');
    if (!hero) return;
    setTimeout(function () {
      $$('.text-line-inner', hero).forEach(function (l) { l.classList.add('visible'); l.style.transform = 'translateY(0)'; });
      $$('[data-hero-fade]', hero).forEach(function (e) { e.style.opacity = e.getAttribute('data-hero-fade'); });
    }, 100);
  })();

  /* ---------- horizontal drag scroller ---------- */
  $$('.h-scroll-container').forEach(function (c) {
    var down = false, sx = 0, sl = 0;
    c.addEventListener('mousedown', function (e) { down = true; sx = e.pageX - c.offsetLeft; sl = c.scrollLeft; });
    w.addEventListener('mouseup', function () { down = false; });
    c.addEventListener('mouseleave', function () { down = false; });
    c.addEventListener('mousemove', function (e) {
      if (!down) return;
      e.preventDefault();
      c.scrollLeft = sl - (e.pageX - c.offsetLeft - sx) * 1.5;
    });
    $$('img', c).forEach(function (im) { im.setAttribute('draggable', 'false'); });
  });

  /* ---------- shop: filters + sort ---------- */
  (function () {
    var shop = $('[data-lv-shop]');
    if (!shop) return;
    var cards = $$('[data-lv-card]', shop), grid = $('[data-lv-grid]', shop), empty = $('[data-lv-empty]', shop);
    var countEl = $('[data-lv-count]', shop);
    var st = { cat: shop.getAttribute('data-default-cat') || 'men', type: 'all', sort: 'featured' };
    var origin = cards.slice();
    var inCat = function (c) { return st.cat === 'all' || c.getAttribute('data-cat') === 'both' || c.getAttribute('data-cat') === st.cat; };
    var typeMenu = $('[data-lv-type-menu]', shop), typeBox = typeMenu && $('.shop-sort__menu', typeMenu);
    var typeLabels = {};
    origin.forEach(function (c) { var k = c.getAttribute('data-type'); if (k) typeLabels[k] = c.getAttribute('data-type-label') || k; });
    function typeBtns() { return typeBox ? $$('[data-type-btn]', typeBox) : []; }
    function updateTypes() {
      if (!typeBox) return;
      var counts = {}, total = 0;
      origin.forEach(function (c) { if (inCat(c)) { var t = c.getAttribute('data-type'); if (t) counts[t] = (counts[t] || 0) + 1; total++; } });
      var keys = Object.keys(counts).sort(function (a, b) { return typeLabels[a].localeCompare(typeLabels[b], lang || undefined); });
      if (st.type !== 'all' && !counts[st.type]) st.type = 'all';
      var allBtn = $('[data-type-btn="all"]', typeBox), allLab = typeMenu.querySelector('.shop-sort__trigger').getAttribute('data-all-label');
      $$('[data-type-btn]:not([data-type-btn="all"])', typeBox).forEach(function (b) { b.parentNode.removeChild(b); });
      keys.forEach(function (k) {
        var b = d.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'option'); b.setAttribute('data-type-btn', k); b.className = 'shop-sort__option'; b.style.transitionDelay = '0ms';
        b.innerHTML = '<span data-type-name></span><em data-type-count></em>';
        $('[data-type-name]', b).textContent = typeLabels[k]; $('[data-type-count]', b).textContent = counts[k];
        typeBox.appendChild(b);
      });
      $('[data-type-count]', allBtn).textContent = total;
      var trg = $('.shop-sort__trigger', typeMenu), lab = $('span', trg);
      typeBtns().forEach(function (b) {
        var on = b.getAttribute('data-type-btn') === st.type;
        b.classList.toggle('is-selected', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      lab.textContent = st.type === 'all' ? allLab : typeLabels[st.type];
      trg.classList.toggle('is-active', st.type !== 'all');
      typeMenu.style.display = keys.length ? '' : 'none';
      var ctrl = typeMenu.closest('.lv-fbar__ctrl'); if (ctrl) ctrl.style.display = keys.length ? '' : 'none';
    }
    function paint() {
      updateTypes();
      var list = origin.filter(function (c) { return inCat(c) && (st.type === 'all' || c.getAttribute('data-type') === st.type); });
      var p = function (c) { return parseFloat(c.getAttribute('data-price')) || 0; };
      if (st.sort === 'priceAsc') list = list.slice().sort(function (a, b) { return p(a) - p(b); });
      if (st.sort === 'priceDesc') list = list.slice().sort(function (a, b) { return p(b) - p(a); });
      if (st.sort === 'newest') list = list.slice().reverse();
      origin.forEach(function (c) { c.style.display = 'none'; });
      list.forEach(function (c) { c.style.display = 'block'; grid.appendChild(c); });
      if (empty) empty.style.display = list.length ? 'none' : 'block';
      if (countEl) countEl.textContent = list.length + ' ' + countEl.getAttribute('data-items-label');
    }
    $$('[data-cat-btn]', shop).forEach(function (b) {
      b.addEventListener('click', function () {
        st.cat = b.getAttribute('data-cat-btn');
        $$('[data-cat-btn]', shop).forEach(function (o) {
          var on = o === b;
          o.style.color = on ? 'var(--color-ink)' : 'var(--color-warm-gray)';
          o.style.borderBottom = on ? '2px solid var(--color-teal)' : '2px solid transparent';
          o.style.fontWeight = on ? 500 : 400;
        });
        paint();
      });
    });
    /* dropdown "a tessuto" generico (categorie + ordina) */
    var drops = [];
    function makeDrop(root, onPick) {
      var trg = $('.shop-sort__trigger', root), mn = $('.shop-sort__menu', root), ch = $('.shop-sort__chevron', root);
      var setS = function (o) {
        var opts = $$('.shop-sort__option', root);
        mn.classList.toggle('is-open', o); ch.classList.toggle('is-open', o); trg.setAttribute('aria-expanded', o ? 'true' : 'false');
        var i = 0; opts.forEach(function (x) { x.style.transitionDelay = o ? ((i++) * 40 + 70) + 'ms' : '0ms'; });
      };
      trg.addEventListener('click', function () {
        var open = !mn.classList.contains('is-open');
        drops.forEach(function (d2) { d2.set(false); });
        setS(open);
      });
      mn.addEventListener('click', function (e) { var o = e.target.closest('.shop-sort__option'); if (o && mn.contains(o)) { onPick(o); setS(false); } });
      var api = { root: root, set: setS };
      drops.push(api);
      return api;
    }
    if (typeMenu) makeDrop(typeMenu, function (o) { st.type = o.getAttribute('data-type-btn'); paint(); });
    var sort = $('[data-lv-sort-menu]', shop);
    if (sort) {
      var lab = $('.shop-sort__trigger span', sort), sopts = $$('.shop-sort__option', sort);
      makeDrop(sort, function (o) {
        st.sort = o.getAttribute('data-sort');
        sopts.forEach(function (x) { x.classList.toggle('is-selected', x === o); x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
        lab.textContent = o.textContent; paint();
      });
    }
    d.addEventListener('mousedown', function (e) { drops.forEach(function (d2) { if (!d2.root.contains(e.target)) d2.set(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') drops.forEach(function (d2) { d2.set(false); }); });
    paint();
  })();

  /* ---------- product page ---------- */
  (function () {
    var pg = $('[data-lv-product]');
    if (!pg) return;
    var data = JSON.parse($('[data-lv-product-json]', pg).textContent);
    var st = { img: 0, size: data.sizes.length ? '' : '_', color: data.colors.length ? data.colors[0].name : '', open: null, added: false, err: '' };
    var NAMES = { nero: '#1a1a1a', black: '#1a1a1a', bianco: '#f5f5f0', white: '#f5f5f0', avorio: '#f5f0e8', ivory: '#f5f0e8', blu: '#1f3a5f', blue: '#1f3a5f', navy: '#1b2a49', rosso: '#9b1c1c', red: '#9b1c1c', verde: '#3b5d3a', green: '#3b5d3a', beige: '#d9c9a8', grigio: '#8a8a8a', grey: '#8a8a8a', gray: '#8a8a8a', rosa: '#e3b5b5', pink: '#e3b5b5', marrone: '#6b4a2f', brown: '#6b4a2f', azzurro: '#7ab3d1', giallo: '#e1c34a', yellow: '#e1c34a', arancione: '#d9772b', orange: '#d9772b', oro: '#c9a24a', gold: '#c9a24a', cammello: '#b98a52', camel: '#b98a52', senape: '#c5a02b', sabbia: '#d8c7a3', panna: '#f1e8d4', cream: '#f1e8d4', tortora: '#a89987', bordeaux: '#6b1d2a', petrolio: '#2d6888', teal: '#2d6888', rame: '#ca7232', copper: '#ca7232' };
    $$('[data-color-btn]', pg).forEach(function (b) {
      var n = b.getAttribute('data-color-btn'), sw = b.getAttribute('data-swatch');
      b.style.background = sw || NAMES[n.toLowerCase()] || n;
    });
    var T = pg.dataset;
    var mainImg = $('[data-lv-main-img]', pg), thumbsBox = $('[data-lv-thumbs]', pg), mGal = $('[data-lv-mgal]', pg), mThumbs = $('[data-lv-mthumbs]', pg), mCount = $('[data-lv-mcount]', pg), mKey = '';
    function colorObj() { return data.colors.filter(function (c) { return c.name === st.color; })[0] || data.colors[0]; }
    function imgs() { var c = colorObj(); return (c && c.images && c.images.length) ? c.images : data.images; }
    function variantId() {
      var v = data.variants.filter(function (x) {
        return (!data.colors.length || x.color === st.color) && (!data.sizes.length || x.size === st.size);
      })[0];
      return v && v.available ? v.id : null;
    }
    function sizeAvailable(sz) {
      return data.variants.some(function (x) { return (!data.colors.length || x.color === st.color) && x.size === sz && x.available; });
    }
    function thumbsHtml(list) {
      return '<span class="lv-pm__frame" aria-hidden="true"></span>' + list.map(function (s, i) {
        return '<button type="button" data-thumb="' + i + '" aria-label="' + (i + 1) + '" class="lv-pm__thumb"><img src="' + s + '" alt="" loading="lazy"></button>';
      }).join('');
    }
    var thumbKey = '', frameInit = false;
    function setThumbOn(i, instant) {
      if (!mThumbs) return;
      var ths = $$('.lv-pm__thumb', mThumbs), fr = $('.lv-pm__frame', mThumbs), on = ths[i];
      ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (!on || !fr) return;
      if (instant || !frameInit) { fr.style.transition = 'none'; }
      fr.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
      if (instant || !frameInit) { void fr.offsetWidth; fr.style.transition = ''; frameInit = true; }
      var left = on.offsetLeft - (mThumbs.clientWidth - on.offsetWidth) / 2;
      if (Math.abs(mThumbs.scrollLeft - left) > 2) mThumbs.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
    }
    function paintMobile(list) {
      if (!mGal) return;
      var key = list.join('|');
      if (key !== mKey) {
        mKey = key;
        mGal.innerHTML = list.map(function (s) { return '<div class="lv-pm__slide"><img src="' + s + '" alt=""></div>'; }).join('');
        mGal.scrollLeft = 0;
      }
      var multi = list.length > 1;
      if (mThumbs) {
        mThumbs.hidden = !multi;
        if (key !== thumbKey) { thumbKey = key; frameInit = false; mThumbs.innerHTML = multi ? thumbsHtml(list) : ''; }
        setThumbOn(st.img);
      }
      if (mCount) { mCount.hidden = !multi; mCount.textContent = (st.img + 1) + ' / ' + list.length; }
      var target = st.img * mGal.clientWidth;
      if (Math.abs(mGal.scrollLeft - target) > 4) { mScrolling = true; mGal.scrollTo({ left: target, behavior: 'smooth' }); setTimeout(function () { mScrolling = false; }, 450); }
    }
    var mScrolling = false, lastGal = '';
    if (mGal) {
      var mTick = null;
      var liveI = -1;
      mGal.addEventListener('scroll', function () {
        if (mScrolling) return;
        var li = Math.round(mGal.scrollLeft / Math.max(mGal.clientWidth, 1));
        if (li !== liveI && li >= 0) { liveI = li; setThumbOn(li); if (mCount) mCount.textContent = (li + 1) + ' / ' + imgs().length; }
        clearTimeout(mTick);
        mTick = setTimeout(function () {
          var i = Math.round(mGal.scrollLeft / Math.max(mGal.clientWidth, 1)), list = imgs();
          if (i !== st.img && i >= 0 && i < list.length) { st.img = i; paint(); }
        }, 80);
      }, { passive: true });
    }
    /* freccia "scorri": la colonna destra scorre indipendentemente dalle foto */
    (function () {
      var grid = $('#product-detail-grid', pg), info = $('.product-detail-info', pg);
      if (!grid || !info) return;
      var hint = d.createElement('button');
      hint.type = 'button'; hint.className = 'lv-scrollhint'; hint.setAttribute('aria-label', isIt ? 'Scorri per vedere altro' : isHi ? 'और देखने के लिए स्क्रॉल करें' : 'Scroll for more');
      hint.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      grid.appendChild(hint);
      function fit() { grid.style.setProperty('--lv-gtop', Math.round(grid.getBoundingClientRect().top + window.pageYOffset) + 'px'); }
      fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
      function upd() {
        var more = window.innerWidth > 900 && info.scrollHeight - info.clientHeight - info.scrollTop > 24;
        hint.classList.toggle('is-on', more);
      }
      info.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      new MutationObserver(upd).observe(info, { childList: true, subtree: true, attributes: true });
      info.addEventListener('transitionend', upd);
      hint.addEventListener('click', function () { info.scrollBy({ top: info.clientHeight * 0.7, behavior: 'smooth' }); });
      setTimeout(upd, 300); setTimeout(upd, 1200);
    })();
    function paint() {
      var list = imgs(), src = list[st.img] || list[0] || '';
      var gkey = list.join('|') + '#' + st.img, galChanged = gkey !== lastGal;
      lastGal = gkey;
      if (galChanged) {
      if (mainImg) { var n = mainImg.cloneNode(); n.src = src; n.style.animation = 'fadeIn 0.4s ease'; mainImg.parentNode.replaceChild(n, mainImg); mainImg = n; }
      paintMobile(list);
      }
      if (thumbsBox && galChanged) {
        thumbsBox.innerHTML = list.length > 1 ? list.map(function (s, i) {
          return '<button type="button" data-thumb="' + i + '" style="width:56px;height:70px;overflow:hidden;border:' + (i === st.img ? '2px solid var(--color-copper)' : '2px solid transparent') + ';padding:0;cursor:pointer;background:#f0ede8;transition:border-color 0.2s ease"><img src="' + s + '" alt="" style="width:100%;height:100%;object-fit:cover"></button>';
        }).join('') : '';
        thumbsBox.style.display = list.length > 1 ? 'flex' : 'none';
      }
      $$('[data-color-name]', pg).forEach(function (e) { e.textContent = st.color; });
      $$('[data-color-btn]', pg).forEach(function (b) {
        var on = b.getAttribute('data-color-btn') === st.color;
        b.classList.toggle('selected', on); b.classList.toggle('is-selected', on);
      });
      $$('[data-size-btn]', pg).forEach(function (b) {
        var sz = b.getAttribute('data-size-btn'), av = sizeAvailable(sz), on = st.size === sz;
        b.classList.toggle('selected', on); b.classList.toggle('is-selected', on);
        b.disabled = !av;
        if (b.classList.contains('size-btn')) { b.style.opacity = av ? 1 : 0.35; b.style.cursor = av ? 'pointer' : 'not-allowed'; b.style.textDecoration = av ? 'none' : 'line-through'; }
      });
      $$('[data-size-hint]', pg).forEach(function (e) { e.style.display = st.size ? 'none' : ''; });
      var allOut = data.variants.length && !data.variants.some(function (x) { return x.available; });
      var emsg = st.err || (allOut ? (T.soldoutLabel || '') : '');
      $$('[data-add-error]', pg).forEach(function (e) { e.textContent = emsg; e.hidden = !emsg; });
      $$('[data-add]', pg).forEach(function (b) {
        var big = b.hasAttribute('data-add-big'), can = !!st.size;
        b.disabled = !can;
        var label = st.added ? ((T.addedLabel || 'OK') + (big ? ' ✓' : '')) : (can ? T.addLabel : T.selectLabel);
        b.textContent = label;
        if (big) {
          b.style.background = can ? (st.added ? 'var(--color-teal)' : 'var(--color-ink)') : 'var(--color-warm-beige)';
          b.style.color = can ? 'var(--color-ivory)' : 'var(--color-warm-gray)';
          b.style.cursor = can ? 'pointer' : 'not-allowed';
        }
      });
      paintAcc();
    }
    function paintAcc() {
      $$('[data-acc]', pg).forEach(function (a) {
        var key = a.getAttribute('data-acc'), on = st.open === key;
        $('.accordion-content', a).classList.toggle('open', on);
        $('[data-plus]', a).style.transform = on ? 'rotate(45deg)' : 'none';
        a.classList.toggle('is-open', on);
      });
    }
    pg.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-thumb]'))) { st.img = parseInt(b.getAttribute('data-thumb'), 10); paint(); return; }
      if ((b = t.closest('[data-color-btn]'))) { st.err = ''; st.color = b.getAttribute('data-color-btn'); st.img = 0; if (st.size && !sizeAvailable(st.size)) st.size = ''; paint(); return; }
      if ((b = t.closest('[data-size-btn]'))) { if (!b.disabled) { st.err = ''; st.size = b.getAttribute('data-size-btn'); paint(); } return; }
      if ((b = t.closest('[data-acc-btn]'))) { var k = b.parentNode.getAttribute('data-acc'); st.open = st.open === k ? null : k; paintAcc(); return; }
      if ((b = t.closest('[data-add]'))) {
        var id = variantId();
        if (!st.size) return;
        if (!id) { st.err = T.soldoutLabel || T.errorLabel || ''; paint(); return; }
        st.err = '';
        Cart.add(id, 1).then(function () {
          st.added = true; paint(); Cart.open();
          setTimeout(function () { st.added = false; paint(); }, 2000);
        }).catch(function (err) {
          if (w.console) console.error('[Leverson] add to cart failed', err);
          st.err = (err && err.shopify && err.message) ? err.message : (T.errorLabel || 'Error');
          paint();
        });
      }
    });
    paint();
  })();

  /* ---------- archive: list ⇄ detail (?c=slug) ---------- */
  (function () {
    var root = $('[data-lv-archive]');
    if (!root) return;
    var slug = new URLSearchParams(location.search).get('c');
    var list = $('[data-lv-archive-list]', root);
    var details = $$('[data-lv-archive-detail]', root);
    var hit = details.filter(function (x) { return x.getAttribute('data-lv-archive-detail') === slug; })[0];
    if (hit) {
      list.style.display = 'none';
      hit.style.display = 'block';
      root.setAttribute('data-detail', '1');
      var nv = $('[data-lv-nav]');
      if (nv) nv.setAttribute('data-nav-kind', 'archive');
      var t = $('title'); if (t && hit.getAttribute('data-title')) t.textContent = hit.getAttribute('data-title') + ' · Leverson';
    }
  })();

  /* ---------- shop: carosello foto nelle card (touch) ---------- */
  (function () {
    var sync = function (tr) {
      var cc = tr.closest('[data-lv-cc]'); if (!cc) return;
      var i = Math.round(tr.scrollLeft / Math.max(tr.clientWidth, 1));
      $$('.lv-cc__dot', cc).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var nn = $$('.lv-cc__slide', cc).length, pv = $('.lv-cc__nav--prev', cc), nx = $('.lv-cc__nav--next', cc);
      if (pv) pv.disabled = i <= 0; if (nx) nx.disabled = i >= nn - 1;
    };
    d.addEventListener('scroll', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('lv-cc__track')) sync(e.target);
    }, true);
    d.addEventListener('click', function (e) {
      var nav = e.target.closest && e.target.closest('.lv-cc__nav');
      if (nav) {
        e.preventDefault(); e.stopImmediatePropagation();
        var c2 = nav.closest('[data-lv-cc]'), t2 = $('.lv-cc__track', c2), n2 = $$('.lv-cc__slide', c2).length;
        var i2 = Math.min(Math.max(Math.round(t2.scrollLeft / t2.clientWidth) + parseInt(nav.getAttribute('data-nav'), 10), 0), n2 - 1);
        t2.scrollTo({ left: i2 * t2.clientWidth, behavior: 'smooth' });
        return;
      }
      var dot = e.target.closest && e.target.closest('.lv-cc__dot');
      if (!dot) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var cc = dot.closest('[data-lv-cc]'), tr = $('.lv-cc__track', cc);
      tr.scrollTo({ left: parseInt(dot.getAttribute('data-dot'), 10) * tr.clientWidth, behavior: 'smooth' });
    }, true);
  })();
})();
